// Eager context over the device resource JSON under resources/common (schema +
// the six initialData blocks; manifest.json etc. are excluded). This replaces
// the per-device import boilerplate: a device's files are addressed by folder id
// at runtime instead of 7 static imports each.
const deviceContext = require.context('../resources/common', true, /\/(schema|initialData(CP|PP|PR|VP|P|V))\.json$/);
/**
 * Load the static resource bundle for a device by its folder id (e.g. 'ABC1234E').
 * Note: the folder must contain the full set of initialData*.json + schema.json;
 * schema-only folders are not valid here.
 */
export function getDeviceResources(deviceId) {
    const load = (name) => deviceContext(`./${deviceId}/${name}.json`);
    return {
        schema: load('schema'),
        V: load('initialDataV'),
        VP: load('initialDataVP'),
        CP: load('initialDataCP'),
        P: load('initialDataP'),
        PR: load('initialDataPR'),
        PP: load('initialDataPP'),
    };
}
